<template>
  <section
    v-if="slice?.Items?.length"
    class="ct-faq"
  >
    <div class="ct-faq__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <UiCollapsable
          v-for="(item) in slice.Items"
          :key="item.Question"
          :label="item.Question"
        >
          <template #icon_before>
            <component
              :is="loadIcon(item.Icon.Icon)"
              v-if="item?.Icon?.Icon"
              filled
              class="ct-faq__icon icon"
              :class="`icon--${useDash(item.Icon.Icon)}`"
            />
          </template>

          <template #icon_after="{ open }">
            <IconMin
              v-if="open"
              class="collapsable__icon icon icon--min"
            />
            <IconPlus
              v-else
              class="collapsable__icon icon icon--plus"
            />
          </template>

          <StrapiBlocksText
            v-if="item?.Answer?.length"
            :nodes="item.Answer"
          />
        </UiCollapsable>
      </div>
    </div>

    <!-- <pre>slice: {{ slice }}</pre> -->
  </section>
</template>

<script lang="ts" setup>
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})

const { loadIcon } = useStrapiIcons()
</script>

<style>
@import url("~layers/app/components/Slices/Faq.css");
</style>
